export default "__VITE_ASSET__a83e1c8a__"